import React from 'react';
import { useBarcode } from 'next-barcode';
import styles from './styles/Barcode.module.scss';

type BarcodeProp = {
  code: string;
};

const Barcode: React.FunctionComponent<BarcodeProp> = (props: BarcodeProp) => {
  const code = props.code;

  const { inputRef } = useBarcode({
    value: code,
    options: {
      format: 'CODE128C',
      width: 2,
      height: 200,
      background: '#f4f5f9',
      displayValue: false,
    },
  });

  return <canvas ref={inputRef} className={styles.barcode} />;
};

export default Barcode;
